import {
    buildImageSource,
    buildImageSourceSet,
    getBaseImageUrl,
} from '../../../../utils/buildImageSource';
import { getMdsUrl } from '../../../../utils/mds/getMdsUrl';
import { IconImage } from '../../../icon/IconImage';
import { Image } from '../../../media/Image';
import { CollagePreviewImageProps } from '../typings';

export const CollagePreviewImage = ({
    preview,
    imageAlias,
    width,
    height,
}: CollagePreviewImageProps) => {
    if (!preview) {
        return <IconImage fontSize="30px" fill="var(--color-primary)" />;
    }

    if (preview.type === 'image') {
        const baseUrl = getBaseImageUrl(preview.media);
        const src =
            imageAlias && baseUrl
                ? getMdsUrl(baseUrl, imageAlias)
                : buildImageSource(preview.media);

        return (
            <Image
                width={width}
                height={height}
                src={src}
                srcSet={imageAlias ? undefined : buildImageSourceSet(preview.media)}
            />
        );
    }

    if (preview.type === 'video' && preview.media[0]?.firstFrameUrl) {
        const src = imageAlias
            ? getMdsUrl(preview.media[0].firstFrameUrl, imageAlias)
            : preview.media[0].firstFrameUrl;

        return <Image width={width} height={height} src={src} />;
    }

    return <IconImage fontSize="30px" fill="var(--color-primary)" />;
};
